import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      "getInsurersTable",
      "setSimulationTable",
      "setSimulationAge",
      "setSimulationStarted",
      "setSimulationSetted",
      "setQuotationUser",
      "setQuotationStarted",
      "setQuotationStep",
      "setQuotationProgress",
      "setEmailSent"
    ])
  },
  created() {
    const localSimulationState = localStorage.localSimulationState
      ? JSON.parse(localStorage.localSimulationState)
      : {}
    const localQuotationStarted = localStorage.quotationStarted
      ? JSON.parse(localStorage.quotationStarted)
      : false
    const localQuotationStepProgress = localStorage.quotationStepProgress
      ? JSON.parse(localStorage.quotationStepProgress)
      : {}
    const localQuotationUser = localStorage.user
      ? JSON.parse(localStorage.user)
      : {}
    const localQuotationEmailSent = localStorage.emailSent
      ? JSON.parse(localStorage.emailSent)
      : false
    this.getInsurersTable().then(response => {
      this.setSimulationTable(response.data);
    });

    if (localSimulationState.started && localSimulationState.set) {
      this.setSimulationAge(localSimulationState.age);
      this.setSimulationStarted(localSimulationState.started);
      this.setSimulationSetted(localSimulationState.set);
    }
    if (localQuotationStarted) {
      this.setQuotationUser(localQuotationUser)
      this.setQuotationStarted(localQuotationStarted);
      this.setQuotationStep(localQuotationStepProgress.step);
      this.setQuotationProgress(localQuotationStepProgress.progress);
      this.setEmailSent(localQuotationEmailSent);
    }
  }
};
